import React from "react";
import {
  SupportedLocale,
  SUPPORTED_LOCALES,
  SwapWidget,
} from "@uniswap/widgets";
import { Tab } from "@headlessui/react";
import styles from "./Home.module.css"; // <-- Uniswap widget styling
import RoundedButton from "../RoundedButton/RoundedButton";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const AddFunds = ({ prevStep, purchaseType, nextStep }) => {
  const TOKEN_LIST = "https://gateway.ipfs.io/ipns/tokens.uniswap.org";
  const UNI = "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984";

  const previous = (e) => {
    e.preventDefault();
    prevStep();
  };

  return (
    <div>
      <Tab.Group>
        <Tab.List className="flex space-x-1 rounded-xl  shadow-md p-1">
          <Tab
            className={({ selected }) =>
              classNames(
                "w-full rounded-lg py-2.5 text-sm leading-6 text-black",
                selected
                  ? "bg-logo-green text-white font-bold"
                  : "text-black font-semibold"
              )
            }
          >
            Deposit Crypto
          </Tab>
          <Tab
            className={({ selected }) =>
              classNames(
                "w-full rounded-lg py-2.5 text-sm leading-6 text-black",
                selected
                  ? "bg-logo-green text-white font-bold"
                  : "text-black font-semibold"
              )
            }
          >
            Pay with Card
          </Tab>
          {purchaseType === "rent" ? (
            <Tab
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm leading-6 text-black",
                  selected
                    ? "bg-logo-green text-white font-bold"
                    : "text-black font-semibold"
                )
              }
            >
              Add NFT Collatoral
            </Tab>
          ) : (
            <Tab
              disabled
              className={({ selected }) =>
                classNames(
                  "w-full rounded-lg py-2.5 text-sm leading-6 text-black disabled:opacity-25 disabled:bg-grey",
                  selected
                    ? "bg-logo-green text-white font-bold"
                    : "text-black font-semibold"
                )
              }
            >
              Add NFT Collatoral
            </Tab>
          )}
        </Tab.List>
        <Tab.Panels className="mt-10">
          <Tab.Panel>
            <div className="flex justify-center">
              <div>
                <SwapWidget
                  jsonRpcEndpoint="https://cloudflare-eth.com"
                  tokenList={TOKEN_LIST}
                  provider=""
                  locale="en-US"
                  onConnectWallet=""
                  defaultInputTokenAddress="NATIVE"
                  defaultInputAmount="1"
                  defaultOutputTokenAddress={UNI}
                />
              </div>
            </div>
          </Tab.Panel>
          <Tab.Panel>
            <div className="flex justify-center">
              <div>
                <iframe
                  style={{
                    borderRadius: "13px",
                    border: "1px solid #58585f",
                    margin: "auto",
                    maxWidth: "360px",
                  }}
                  src={`https://buy.onramper.com/?apiKey=${process.env.REACT_APP_ONRAMPER_API_KEY_DEV}`}
                  height="540px"
                  width="360px"
                  title="Onramper widget"
                  allow="accelerometer; autoplay; camera; gyroscope; payment"
                />
              </div>
            </div>
          </Tab.Panel>
          <Tab.Panel>Content 3</Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
      <div className="mt-10">
        <RoundedButton outline={true} onClick={previous}>
          Previous
        </RoundedButton>
      </div>
    </div>
  );
};
export default AddFunds;
